import { render, staticRenderFns } from "./MilitaryStatusTypeUpdate.vue?vue&type=template&id=686bfc74&"
import script from "./MilitaryStatusTypeUpdate.vue?vue&type=script&lang=js&"
export * from "./MilitaryStatusTypeUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports